import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://asylumdistro.com";
export const SITE_NAME = "Asylum Entertainment";
export const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;
export const SOCIALS = ["https://www.tiktok.com/@asylumdistro", "https://www.instagram.com/asylumdistro", "https://www.facebook.com/asylumdistro"];

export const ORG_SCHEMA = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: SITE_NAME,
  alternateName: ["Asylum Distro", "Asylum Records Distribution"],
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  description: "Independent music distribution label. Upload once, release to Spotify, Apple Music, TIDAL and 150+ platforms under the Asylum Entertainment label name — keep 100% of your royalties for one flat annual fee.",
  sameAs: SOCIALS,
};

export const WEBSITE_SCHEMA = {
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en-US",
};

export const breadcrumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL}${path}` })),
});

export default function Seo({ title, description, path = "/", image = DEFAULT_IMAGE, imageSize = [1200, 630], type = "website", noindex = false, jsonLd = [] }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Independent Music Distribution`;
  const url = `${SITE_URL}${path}`;
  const graph = { "@context": "https://schema.org", "@graph": [ORG_SCHEMA, WEBSITE_SCHEMA, ...jsonLd] };
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content={String(imageSize[0])} />
      <meta property="og:image:height" content={String(imageSize[1])} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {!noindex && <script type="application/ld+json">{JSON.stringify(graph)}</script>}
    </Helmet>
  );
}
